module.exports = __webpack_public_path__ + "04_mole.1bfdcc83.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/04_mole.png
// module id = Fj6r
// module chunks = 0